import Molde from "./MoldeTransporte";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function TransporteCusco_valle() {
  return (
      <>
        <Molde
          image={"/images/cusco_valle_t.png"}
          title={"TRANSPORTE AEROPUERTO CUSCO - VALLE SAGRADO"}
          subtitle={"(Todo el día)"}
          description={
            "Este servicio de transporte privado ofrece un traslado cómodo y directo desde el Aeropuerto Internacional Alejandro Velasco Astete de Cusco hasta el Valle Sagrado de los Incas. El Valle Sagrado es una de las principales zonas turísticas de la región, conocida por su belleza natural, sitios arqueológicos y pueblos tradicionales. Este servicio es ideal para aquellos que desean un transporte privado y directo desde el aeropuerto hasta el Valle Sagrado, sin tener que preocuparse por el transporte público o los traslados en grupo. El viaje tiene una duración aproximada de 1.5 a 2 horas, dependiendo de las condiciones del tráfico y el punto de destino dentro del Valle Sagrado. Durante el trayecto, los viajeros podrán disfrutar de impresionantes paisajes andinos, montañas y vistas panorámicas de la región."
          }
          
          //linkForm={"/reservar/citytour-dia"}
          //tipoprecio={"Precio por persona"}
          //monto={"US$ 11.00"}
          //moneda={"DOLARES"}
  
          picture1={            
            <>
            <div>
              <CardItinerario
                num="01"
                title="RECOJO"
                lugar="AEROPUERTO CUSCO"
                ></CardItinerario>
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                  <div className="m-8">
                    <p className="text-justify text-primary-800"><strong>Punto de Recogida:</strong> El conductor estará esperando a los viajeros en el área de llegadas del Aeropuerto de Cusco con un cartel que indica el nombre de la reserva o el nombre del viajero. El conductor se asegurará de que los viajeros sean recibidos de manera puntual y profesional.</p>
                    <p className="text-justify text-primary-800" ><strong>Hora de Recogida:</strong> El servicio está disponible para cualquier vuelo que llegue al aeropuerto de Cusco. Asegúrate de proporcionar los detalles del vuelo para que el conductor esté disponible a la hora exacta de llegada.</p>
                    <p className="text-justify text-primary-800"><strong>Vehículo:</strong> El servicio se realiza en vehículos cómodos y bien equipados, como minibuses, vans o coches privados, dependiendo del número de personas que viajan. Todos los vehículos son modernos y cuentan con aire acondicionado.</p>
                  </div>
                  <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/aero_1.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/aero_2.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/aero_3.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/aero_4.png`} alt="" />
                  </div>
                  
                </div>
              </div>
            </>
          }
  
          picture2={            
            <>
            <div>
              <CardItinerario
                num="02"
                title="TRAYECTO"
                lugar="A VALLE SAGRADO"
                ></CardItinerario>
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                  <div className="p-8">
                    <p className="text-justify text-primary-800"><strong>Duración:</strong> El trayecto desde el Aeropuerto de Cusco hasta el Valle Sagrado toma entre 1.5 y 2 horas, dependiendo del punto de destino en el Valle Sagrado y las condiciones de tráfico.</p>
                    <p className="text-justify text-primary-800" ><strong>Ruta:</strong> El viaje tomará la carretera principal desde Cusco, pasando por Urubamba, hasta llegar a otros pueblos del Valle Sagrado, como Ollantaytambo, Pisac o Chinchero, según lo que se haya solicitado.</p>
                    <p className="text-justify text-primary-800"><strong>Vistas panorámicas:</strong> Durante el trayecto, los viajeros disfrutarán de vistas panorámicas del Valle Sagrado, con montañas, valles, campos agrícolas y pueblos típicos andinos.</p>
                  </div>
                  <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_2.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_4.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_3.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_1.png`} alt="" />
                  </div>
                </div>
              </div>
            </>
          }
  
          picture3={            
            <>
            <div>
              <CardItinerario
                num="03"
                title="LLEGADA"
                lugar="VALLE SAGRADO"
                ></CardItinerario>
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                  <div className="p-8">
                    <p className="text-justify text-primary-800"><strong>Punto de Llegada:</strong> Durante el trayecto, los viajeros disfrutarán de vistas panorámicas del Valle Sagrado, con montañas, valles, campos agrícolas y pueblos típicos andinos.</p>
                      <p className="text-justify text-primary-800" ><strong>Hora de Llegada:</strong> La llegada dependerá de la hora de salida del vuelo y el destino específico dentro del Valle Sagrado. El servicio estará diseñado para ajustarse al horario del vuelo y las necesidades del viajero.</p>
                  </div>
                  <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-1.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-home.png`} alt="" />
                  </div>
                </div>
              </div>
            </>
          }
          
  
          incluye={
            <>
              <p className="text-primary-800 font-light">Transporte turistico</p>
              <p className="text-primary-800 font-light">Guia profesional</p>
              <p className="text-primary-800 font-light">Asistencia permanente</p>
            </>
          }
          noIncluye={
            <>
              <p className="text-primary-800 font-light">Ingreso a koricancha </p>
              <p className="text-primary-800 font-light">Boleto turistico </p>
              <p className="text-primary-800 font-light">Gastos extra</p>
            </>
          }
          caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/auto_t.svg`}
                title={"Vehiculo"}
                desc={"Auto moderno"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"VIP"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"1.5 a 2 Horas"}
              />
              {/*
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural"}
              />*/}
            </>
          }
          
          TourRecomienda={
            <>
              <CardRecomienda
                img={"/images/montania_colores.png"}
                title={"MONTAÑA 7 COLORES"}
                puntuacion={"4.5"}
                link={'/tour-tradicional/montania-colores'}
              />
              <CardRecomienda
                img={"/images/valle-vip-5.png"}
                title={"VALLE VIP"}
                puntuacion={"5"}
                link={'/tour-tradicional/valle-vip'}
              />
              <CardRecomienda
                img={"/images/laguna_huamantay.png"}
                title={"LAGUNA HUAMANTAY"}
                puntuacion={"5"}
                link={'/tour-tradicional/laguna-huamantay'}
              />
              <CardRecomienda
                img={"/images/maras-moray-4.png"}
                title={"MARAS-MORAY"}
                puntuacion={"4.5"}
                link={'/tour-tradicional/maras-moray'}
              />
            </>
          }
        />
      </>
    );
}
